import React from "react";
import AdminPage from "../AdminPage";
import useAdminList from "../useAdminList";
import InvestorsVerifiedData from "../InvestorsVerifiedData/InvestorsVerifiedData";

const COPY = {
  title: "Verified Investors",
  subtitle: "You Can See Detail About Verified Investors",
  searchPlaceholder: "Search Here",
};

const InvestorsVerified = () => {
  const { items, loading, searchValue, setSearchValue } = useAdminList(
    "getUsers",
    "fullName"
  );

  return (
    <AdminPage
      title={COPY.title}
      subtitle={COPY.subtitle}
      loading={loading}
      search={{
        value: searchValue,
        onChange: setSearchValue,
        placeholder: COPY.searchPlaceholder,
      }}
    >
      <InvestorsVerifiedData driverData={items} />
    </AdminPage>
  );
};

export default InvestorsVerified;
